module.exports = __webpack_public_path__ + "static/img/ico_login_wh_m.245d881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/ico_login_wh_m.png
// module id = hvKc
// module chunks = 10